import React from 'react';

const Header = ({title, subtitle}) => {
  return (
    <div className="pad--ends header">
      <h1 className="section-title center">
        {title}
      </h1>
      <div className="pad--top pad-half--sides">
        <div className="tagline">{subtitle}</div>
      </div>
    </div>
  );
};

export default Header;
